import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData } from '../../services/videosGalleryServices';
import { Modal, Button, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Videosgallery = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  const [dataList, setDataList] = useState([]);
  const [form, setForm] = useState({ id: '', video_order: '', video_code: '', video_title: '' });
  const [editingId, setEditingId] = useState(null);
  const [modalType, setModalType] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  // Fetch data list
  const fetchData = useCallback(async () => {
    setLoading(true); 
    try{
    const data = await getData();
    setDataList(data);
  }
  catch (error) {
    console.error('Failed to fetch data:', error);
  }
  finally {
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

 const validateForm = () => {
    const newErrors = {};
    if (!form.video_order) newErrors.video_order = "Order  is required";  
    if (!form.video_code) newErrors.video_code = "Video Code is required";
    if (!form.video_title) newErrors.video_title = "Video Title is required";
    if (!form.video_title) newErrors.video_title = "Video Title is required";
    if (form.video_code && !/^[a-zA-Z0-9_-]{11}$/.test(form.video_code)) {
      newErrors.video_code = "Invalid YouTube video code";
    }
    if (form.video_order && !/^[0-9]+$/.test(form.video_order)) {
      newErrors.video_order = "Video Order must be a number";
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };

    const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      let updatedErrors = { ...errors };
      
      // Update form state
      setForm((prev) => ({ ...prev, [name]: value }));

      // Clear error if the field has a value
      if (value) {
        updatedErrors[name] = '';
      }
      
      // Field-specific validations
      if (name === 'video_order') {
          if (value.trim() === '') {
          updatedErrors[name] = "Video Order is required";
        }
        else if (!/^[0-9]+$/.test(value)) {
          updatedErrors[name] = "Video Order must be a number";
        } else if (Number(value) === 0) {
          updatedErrors[name] = "Order value must be greater than zero";
        } else {
          const isDuplicate = dataList.some((item) => {
            if (item.id === editingId) return false; // skip current editing item
            return item?.video_order === Number(value);
          });
          if (isDuplicate) {
            updatedErrors[name] = "Order already exists";
          }
        }
      }

      if (name === 'video_code' && !/^[a-zA-Z0-9_-]{11}$/.test(value)) {
        updatedErrors[name] = "Invalid YouTube video code";
      }

      setErrors(updatedErrors);
    } catch (error) {
      console.error('Error in handleChange:', error);
    }
  };
  const handleSubmit = async (e) => {
    try{
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    let result;
    if (modalType === 'add') {
      result =  await addData(form);
    } else if (modalType === 'edit') {
      result =  await updateData(form);
    }
    if (result?.status === 200||201) {
    fetchData();  // Re-fetch data after adding/editing
    setShowModal(false);
    toast.success("saved successfully!", {
                    position: 'top-right',
                  });
          }
          else {
            toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right'});
          }
      }
      catch (error) {   
        console.error('Error during form submission:', error);
      }
  };

  const handleDelete = async () => {
    try{
      if (selectedData) {
        // Optimistically remove the data from the list
        setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
        // Proceed with the actual delete request
        await deleteData(selectedData);
        setShowDeleteConfirmModal(false);
        toast.success("Deleted successfully!", {
                      position: 'top-right',
                      autoClose: 3000,
                    });
      }
  }
      catch(error){
        console.error('Failed to delete getData:', error);
      };
  };

  const openModal = (type, data = { id: '', video_order: '', video_code: '', video_title: '' }) => {
    setModalType(type);
    setEditingId(data?.id); 
    setForm(data);
    setShowModal(true);
  };
  
  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    try{
     const filtered = dataList.filter(
      (data) =>
      data.video_title.toLowerCase().includes(searchText.toLowerCase()) ||
      data.video_code.toLowerCase().includes(searchText.toLowerCase())
    );
    const sortedData = [...filtered].sort((a, b) => new Date(a.video_order) - new Date(b.video_order));
    return sortedData;
  }
  catch(error){ 
    console.error('Failed to fetch data:', error);
  }
  }, [dataList, searchText]);

  const columns = [
    // {
    //   name: '#',
    //   selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
    //   sortable: false,
    //   width: '80px',
    // },
    {
      name: 'Video Order',
      selector: (row) => row.video_order,
      sortable: true,
    },
    {
        name: 'Video Thumbnail',
        selector: (row) => (
            <img 
                src={`https://img.youtube.com/vi/${row.video_code}/maxresdefault.jpg`} 
                width="100" 
                style={{ width: '60px', height: '40px', objectFit: 'cover' }}
                crossOrigin="anonymous"
                alt={row.webinar_code} 
            />
        ),
        sortable: false,
    },
    {
      name: 'Video Title',
      selector: (row) => row.video_title,
      cell: (row) => (
            <span title={row.video_title}>
              {row.video_title}
            </span>
          ),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button className="me-2" variant="warning" size="sm" onClick={() => openModal('edit', row)} > Edit </Button>
          <Button variant="danger" size="sm" onClick={() => openDeleteConfirmModal(row)} > Delete </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
      const tooltipMap = {
        'ql-bold': 'Bold',
        'ql-italic': 'Italic',
        'ql-underline': 'Underline',
        'ql-strike': 'Strikethrough',
        'ql-script[value="sub"]': 'Subscript',
        'ql-script[value="super"]': 'Superscript',
        'ql-blockquote': 'Blockquote',
        'ql-code-block': 'Code Block',
        'ql-color': 'Text Color',
        'ql-background': 'Background Color',
        'ql-align': 'Align',
        'ql-direction': 'Text Direction',
        'ql-list[value="ordered"]': 'Ordered List',
        'ql-list[value="bullet"]': 'Bullet List',
        'ql-indent[value="-1"]': 'Outdent',
        'ql-indent[value="+1"]': 'Indent',
        'ql-link': 'Insert Link',
        // 'ql-formula': 'Insert Formula',
        'ql-clean': 'Clear Formatting',
      };

    const setTooltips = () => {
      Object.entries(tooltipMap).forEach(([selector, title]) => {
        const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
        if (el && !el.title) {
          el.setAttribute('title', title);
        }
      });
    };

    const observer = new MutationObserver((mutations, obs) => {
      const toolbarReady = document.querySelector('.ql-toolbar');
      if (toolbarReady) {
        setTooltips();
        obs.disconnect(); // Stop observing once done
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

  return () => observer.disconnect() // Clean up on unmount
  }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className="fs-4">Event Pages / Conference <b>/  Video Gallery</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 " onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom' >Video Order <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="video_order" value={form.video_order} onChange={handleChange} isInvalid={!!errors.video_order}/>
                  <Form.Control.Feedback type="invalid">{errors.video_order}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Video Code <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="video_code" value={form.video_code} onChange={handleChange} isInvalid={!!errors.video_code}/>
                  <Form.Control.Feedback type="invalid">{errors.video_code}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Video Title <small className='text-danger'> * </small></Form.Label>
                  <Form.Control type="text" name="video_title" value={form.video_title} onChange={handleChange} isInvalid={!!errors.video_title} />
                <Form.Control.Feedback type="invalid">{errors.video_title}</Form.Control.Feedback>
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowModal(false)}> Cancel </Button>
              <Button variant="primary" onClick={handleSubmit}> {modalType === 'add' ? 'Add' : 'Save'} </Button>
            </Modal.Footer>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={() => setShowDeleteConfirmModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer className='border-0'>
              <Button variant="secondary" onClick={() => setShowDeleteConfirmModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
        )}
      </div>
    </div>
  );
};

export default Videosgallery;